'use client';

import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@common/components';
import { useSuspenseQuery } from '@tanstack/react-query';
import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { AuthQueryOptions } from '@/api';
import { FestivalCard } from '@/app/(allowed)/festival/_components/FestivalCard';
import { EmptyScrapList } from './EmptyScrapList';
const FestivalScrapListContent = () => {
  const $ = _c(11);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      ...AuthQueryOptions["get:/wello/v2/auth/member/wishlist/tour-festival"](),
      select: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data: festivalScrapList
  } = useSuspenseQuery(t0);
  if (!festivalScrapList.length) {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <EmptyScrapList />;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] !== festivalScrapList.length) {
    t1 = <p className="px-20 py-10 font-500 text-Gray-black typo-body4">총 {festivalScrapList.length}개</p>;
    $[2] = festivalScrapList.length;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== festivalScrapList) {
    t2 = festivalScrapList.map(_temp2);
    $[4] = festivalScrapList;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <ul className="m-0 grid list-none gap-x-12 gap-y-32 p-0 px-20 mobile:grid-cols-1 tablet:grid-cols-2 xl:grid-cols-2">{t2}</ul>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t3) {
    t4 = <article className="flex flex-col">{t1}{t3}</article>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export const FestivalScrapList = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Skeleton className="my-10 ml-20 h-21 w-45 rounded-xxsmall" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ErrorBoundary fallback={null}><Suspense fallback={<article className="flex flex-col">{t0}<ul className="m-0 grid list-none gap-x-12 gap-y-32 p-0 px-20 mobile:grid-cols-1 tablet:grid-cols-2 xl:grid-cols-2">{Array.from({
            length: 4
          }).map(_temp3)}</ul></article>}><FestivalScrapListContent /></Suspense></ErrorBoundary>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
function _temp(t0) {
  const {
    context
  } = t0;
  return context ?? [];
}
function _temp2(festival) {
  return <li key={festival.tourId}><FestivalCard festival={{
      id: festival.tourId,
      title: festival.title,
      firstImage: festival.firstImage,
      addr1: festival.addr1,
      eventplace: festival.eventplace,
      eventstartdate: festival.eventstartdate,
      eventenddate: festival.eventenddate
    }} /></li>;
}
function _temp3(_, index) {
  return <li key={index} className="flex flex-col gap-12"><Skeleton className="aspect-[343/268] w-full rounded-xsmall mobile:rounded-medium" /><Skeleton className="h-24 w-200" /><div className="flex flex-col gap-4"><Skeleton className="h-16 w-1/2" /><Skeleton className="h-16 w-2/3" /></div></li>;
}